module.exports = __webpack_public_path__ + "img/ol.8c433c5b.svg";